
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Pimplesaudagar() {



    const cardData =
    {
        keyword: '  Pimple Saudagar to Mumbai Cab Service ',
        heading: 'Skyline Cabs: Pimple Saudagar to Mumbai Cab Service ',
        headingDescription: 'Skyline Cabs offers dependable and comfortable Pimple Saudagar to Mumbai Cab Service. Whether you are traveling for a business meeting, a leisurely trip, or need an airport transfer, our well-maintained vehicles and experienced drivers ensure a smooth and timely journey. Enjoy a stress-free ride with Skyline Cabs, where punctuality, comfort, and customer satisfaction are our top priorities. Book your Pimple Saudagar to Mumbai cab today and experience hassle-free travel at competitive prices.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pimple Saudagar to Mumbai Cab",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Pimple Saudagar to Mumbai. Whether you're traveling for business or leisure, we ensure timely and comfortable rides with a variety of vehicle options including Innova and Ertiga."
    },
    {
      "name": "Pimple Saudagar to Mumbai Airport Cab",
      "description": "Book your hassle-free airport transfer from Pimple Saudagar to Mumbai International Airport with Skyline Cabs. Choose from luxurious options like Innova Crysta or affordable vehicles like Ertiga for your airport drop."
    },
    {
      "name": "Pimple Saudagar to Mumbai International Airport",
      "description": "For a seamless ride to Chhatrapati Shivaji International Airport from Pimple Saudagar, choose Skyline Cabs. Our expert drivers ensure on-time arrivals, making your journey smooth and stress-free."
    },
    {
      "name": "Pimple Gurav to Mumbai Cab Service",
      "description": "Skyline Cabs offers taxi services from Pimple Gurav to Mumbai, ensuring a comfortable and timely journey. We offer a range of vehicles to suit your needs, including Innova, Ertiga, and more."
    },
    {
      "name": "Taxi Service in Pimple Gurav",
      "description": "Skyline Cabs provides reliable and affordable taxi services within Pimple Gurav and to surrounding areas. Whether for business or leisure, our fleet is ready to meet your travel requirements."
    },
    {
      "name": "Taxi Service in Pimple Saudagar Pune",
      "description": "Skyline Cabs offers local taxi services within Pimple Saudagar, Pune, and intercity rides to Mumbai, making it easier for you to travel with comfort and convenience."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a cab from Pune to Mumbai Airport with Skyline Cabs. Enjoy a comfortable and safe ride to the airport with well-maintained vehicles and professional drivers."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel in comfort with Skyline Cabs' Ertiga cab service from Pune to Mumbai. The Ertiga offers ample space for families or small groups, ensuring a comfortable and enjoyable journey."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "For a premium ride from Pune to Mumbai, book an Innova cab with Skyline Cabs. The Innova is ideal for a family or group travel, offering luxury, space, and comfort."
    },
    {
      "name": "Top-rated Mumbai to Pimple Saudagar Cabs",
      "description": "Skyline Cabs offers top-rated, affordable, and reliable taxi services from Mumbai to Pimple Saudagar. Enjoy a comfortable and safe ride with our experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Pimple Saudagar to Dadar Cab Service",
      "description": "Book a cab from Pimple Saudagar to Dadar with Skyline Cabs. We offer reliable and comfortable rides to Dadar, with various vehicle options available."
    },
    {
      "name": "Pimple Gurav to Dadar Cab Service",
      "description": "Skyline Cabs provides taxi services from Pimple Gurav to Dadar. Choose from a variety of vehicles, including Innova and Ertiga, for your ride to Dadar."
    },
    {
      "name": "Cab Service in Pimple Gurav",
      "description": "Skyline Cabs offers a range of local and intercity taxi services in Pimple Gurav. Whether you need a ride to the airport or a trip to Mumbai, we offer competitive pricing and excellent service."
    },
    {
      "name": "Taxi Service in Pimple Saudagar Pune",
      "description": "Skyline Cabs offers convenient taxi services in Pimple Saudagar, Pune, for both local and intercity rides. We provide affordable, reliable, and timely transportation for your daily travel needs."
    },
    {
      "name": "Innova Crysta on Rent in Pimple Saudagar Pune",
      "description": "Skyline Cabs offers the luxurious Innova Crysta on rent in Pimple Saudagar, Pune, for group travel, corporate trips, or family vacations. Rent the best vehicles at competitive rates."
    },
    {
      "name": "Pimple Saudagar to Andheri Cab",
      "description": "Skyline Cabs offers direct and convenient taxi services from Pimple Saudagar to Andheri. Choose from various vehicle options for your journey to one of Mumbai’s busiest business and entertainment hubs."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Skyline Cabs offers round trip cab services from Pune to Mumbai. Whether you need a one-day or multi-day trip, we ensure comfort and flexibility in our services at affordable rates."
    },
    {
      "name": "Ertiga on Rent in Pimple Saudagar",
      "description": "Rent an Ertiga in Pimple Saudagar with Skyline Cabs for your family trips, group outings, or business travel. Our rental services are flexible and come with the option of chauffeur-driven cabs."
    },
    {
      "name": "Ertiga on Rent in Pimple Saudagar",
      "description": "For a comfortable and budget-friendly vehicle, rent the Ertiga from Skyline Cabs in Pimple Saudagar. Perfect for group travel or family trips, Ertiga is a great choice for your transport needs."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides reliable, 24/7 taxi services in Pune for local and intercity travel. From airport transfers to business trips, we ensure a comfortable and convenient ride every time."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a taxi service from Pune to Mumbai Airport with Skyline Cabs. We offer comfortable, reliable, and affordable rides to Chhatrapati Shivaji International Airport with on-time arrival."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs offers a convenient and affordable taxi service from Pune to Mumbai. Enjoy a stress-free ride with well-maintained vehicles, available 24/7 for your travel needs."
    },
    {
      "name": "Cab Service Pimple Saudagar Pune",
      "description": "Skyline Cabs offers reliable taxi services in Pimple Saudagar, Pune, for local and intercity travel. We offer comfortable rides at affordable prices with various vehicle options."
    }
  ],
  "tableData": [
    ["Pimple Saudagar to Mumbai Cab", "Pimple Saudagar to Mumbai Airport Cab"],
    ["Pimple Saudagar to Mumbai International Airport", "Pimple Gurav to Mumbai Cab Service"],
    ["Taxi Service in Pimple Gurav", "Taxi Service in Pimple Saudagar Pune"],
    ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Top-rated Mumbai to Pimple Saudagar Cabs"],
    ["Pimple Saudagar to Dadar Cab Service", "Pimple Gurav to Dadar Cab Service"],
    ["Cab Service in Pimple Gurav", "Taxi Service in Pimple Saudagar Pune"],
    ["Innova Crysta on Rent in Pimple Saudagar Pune", "Pimple Saudagar to Andheri Cab"],
    ["Pune to Mumbai Cab Round Trip", "Ertiga on Rent in Pimple Saudagar"],
    ["Ertiga on Rent in Pimple Saudagar", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
    ["Cab Service Pimple Saudagar Pune", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Pimple Saudagar to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and punctual cab services from Pimple Saudagar to Mumbai, ensuring you reach your destination on time, whether it's for a business meeting, a weekend getaway, or a family trip. Our services are designed for your comfort and convenience."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars, guarantees a comfortable ride from Pimple Saudagar to Mumbai. Enjoy ample legroom, air-conditioning, and a smooth ride, making your journey a relaxing experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs drivers are courteous, experienced, and familiar with the best routes from Pimple Saudagar to Mumbai. They ensure your safety and comfort throughout the journey, adhering to safe driving practices and traffic conditions."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Fares",
        "WhyChoosedescription": "We offer competitive and transparent pricing for all trips between Pimple Saudagar and Mumbai. No hidden fees, no surprise charges—just clear, upfront fares that make budgeting easy for you."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available round-the-clock, ensuring that you can book a cab from Pimple Saudagar to Mumbai at any time that suits you. Whether it’s an early morning flight or a late-night arrival, we’re always here to serve you."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "Whether you're traveling alone or in a group, we have the perfect vehicle for your needs. Choose from a variety of vehicles such as hatchbacks, sedans, SUVs, and luxury cars, all well-maintained for a comfortable and enjoyable ride."
    },
    {
        "WhyChooseheading": "Easy Online Booking Process",
        "WhyChoosedescription": "Booking a cab from Pimple Saudagar to Mumbai is quick and easy with our online platform. Use our website or mobile app to book a ride in minutes, get instant booking confirmation, and track your ride in real-time."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "Your safety is our top priority. All Skyline Cabs are equipped with GPS for real-time tracking, and our drivers are background-checked for your peace of mind. Enjoy a secure and comfortable ride from Pimple Saudagar to Mumbai with Skyline Cabs."
    }
]










    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Pimple Saudagar to Mumbai with Skyline Cabs?',
            answer:
                'Booking your cab is hassle-free! You can visit our website, use the Skyline Cabs mobile app, or call our customer service team. Just enter your pickup from Pimple Saudagar and drop location in Mumbai, choose your vehicle, and confirm your booking instantly.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Pimple Saudagar to Mumbai travel?',
            answer:
                'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you’re traveling alone, with family, or a group, we have a vehicle that suits your needs.',
        },
        {
            id: 3,
            question: 'Is the fare from Pimple Saudagar to Mumbai fixed or based on distance?',
            answer:
                'Skyline Cabs offers fixed and transparent pricing for your Pimple Saudagar to Mumbai ride. All tolls, taxes, and any additional charges are clearly communicated during booking.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Pimple Saudagar to Mumbai?',
            answer:
                'Yes, you can book either a one-way or round-trip cab for your journey. Just select the type of trip during booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey from Pimple Saudagar to Mumbai take?',
            answer:
                'The journey typically takes between 3 to 3.5 hours, depending on the traffic. Our drivers are experienced and ensure you have a safe and timely arrival.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all our drivers are background-verified, experienced, and trained to provide a safe and comfortable ride. They are familiar with the Pimple Saudagar to Mumbai route and ensure a smooth journey.',
        },
        {
            id: 7,
            question: 'Can I schedule a Pimple Saudagar to Mumbai cab in advance?',
            answer:
                'Yes, you can easily schedule your ride in advance via our website or mobile app. We recommend booking ahead for peak hours or weekends to ensure vehicle availability.',
        },
        {
            id: 8,
            question: 'Is airport drop from Pimple Saudagar to Mumbai available?',
            answer:
                'Yes, we offer direct cab services from Pimple Saudagar to Mumbai Domestic and International Airports. Let us know your flight details for timely drop-off.',
        },
        {
            id: 9,
            question: 'Can I make changes to or cancel my Pimple Saudagar to Mumbai booking?',
            answer:
                'Yes, you can modify or cancel your booking through our app or website. Our flexible cancellation and modification policy ensures convenience.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Pimple Saudagar to Mumbai cab service?',
            answer:
                'Skyline Cabs ensures a stress-free and comfortable journey with experienced drivers, well-maintained cars, and transparent pricing. We’re committed to providing reliable, timely, and affordable cab services.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Tanmay Joshi",
            rating: 5,
            review: "I booked a one-way cab from Pimple Saudagar to Mumbai for a business trip. The booking was quick and easy, the car was clean and comfortable, and the driver was professional. I will definitely choose Skyline Cabs again!"
        },
        {
            name: "Miss. Swati Deshpande",
            rating: 4,
            review: "I traveled from Pimple Saudagar to Mumbai with Skyline Cabs. The ride was smooth, and the driver was friendly. Only suggestion – adding WiFi in the car would be a great addition for long trips. Overall, great service!"
        },
    ];
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/pimple-saudagar-to-mumbai-cab.jpg",
  "description": "Book Pimple Saudagar to Mumbai cab service with Skyline Cabs for a reliable, affordable, and safe journey. Enjoy AC sedans, SUVs, and experienced drivers—available for one-way or round-trip rides 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7812"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pimple-saudagar-to-mumbai-cab-service"
  }
};



     
      


    return (
        <div>
<Helmet>
  <title>Pimple Saudagar to Mumbai Cab Service | 24/7 Travel | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pimple Saudagar to Mumbai cab service with Skyline Cabs for a reliable, affordable, and safe journey. Enjoy AC sedans, SUVs, and experienced drivers—available for one-way or round-trip rides 24/7." 
  />
  <meta 
    name="keywords" 
    content="Pimple Saudagar to Mumbai Cab Service, Cab from Pimple Saudagar to Mumbai, One-Way Taxi Pimple Saudagar to Mumbai, Round Trip Cab Pimple Saudagar Mumbai, AC Sedan Cab Pimple Saudagar Mumbai, SUV Taxi Pimple Saudagar to Mumbai, Affordable Cab Service Pimple Saudagar to Mumbai, Online Cab Booking Skyline Cabs, 24/7 Cab Pimple Saudagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimplesaudagar;